export default __webpack_public_path__ + "static/media/toggler.788a53d2.svg";